import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { auditReports } from '@mi-front/api-clients';
import { MrtTable } from '@mi-front/ui';
import { Box, FormControlLabel, Switch } from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import { defineMessage, useIntl } from 'react-intl';
import { useGipReportResultFilter_v2 } from './useGipReportResultFilter';
import { useGipResultColumnsFactory } from './useGipResultColumnsFactory';

interface Props {
  schedules: auditReports.GipReportMatchedScheduleDto[];
}

const showOffToleranceMessage = defineMessage({
  id: 'audit.gipReport.result.showOffTolerance',
  defaultMessage: 'Mostrar resultados fuera de tolerancia',
});

/**
 * Matched schedules table with an off-tolerance visibility toggle in the toolbar.
 */
export function GipReportMatchedSchedulesView({ schedules }: Props) {
  const { $t } = useIntl();
  const columns = useGipResultColumnsFactory();
  const showScheduleDatetimeColumn = useFeatureIsOn('app__audit_gip_show_schedule_datetime_column');

  const { showOffTolerance, setShowOffTolerance, filteredItems } =
    useGipReportResultFilter_v2(schedules);

  const tableColumns = [
    columns.station,
    columns.matchDateTime,
    ...(showScheduleDatetimeColumn ? [columns.dateTime] : []),
    columns.customId,
    columns.advertiser,
    columns.campaign,
    columns.version,
    columns.contract,
    columns.order,
    columns.offToleranceIndicator,
    columns.actions,
  ].filter(Boolean) as unknown as MRT_ColumnDef<auditReports.GipReportMatchedScheduleDto>[];

  return (
    <MrtTable<auditReports.GipReportMatchedScheduleDto>
      data={filteredItems}
      columns={tableColumns}
      renderTopToolbarCustomActions={() => (
        <Box sx={{ display: 'flex', alignItems: 'center', p: 1 }}>
          <FormControlLabel
            control={
              <Switch
                size="small"
                color="primary"
                checked={showOffTolerance}
                onChange={(_event, checked) => setShowOffTolerance(checked)}
              />
            }
            label={$t(showOffToleranceMessage)}
            sx={{
              m: 0,
              '& .MuiFormControlLabel-label': { typography: 'body2' },
            }}
          />
        </Box>
      )}
      muiTableBodyCellProps={({ row }) => {
        const match = row.original.match;

        const classes =
          match?.matchedScheduleConfirmationType === 'OFF_TOLERANCE' ? 'text-yellow' : '';

        return {
          classes: {
            root: classes,
          },
        };
      }}
    />
  );
}
